<div class="theme-section">
    <div class="theme-controls-center">
        <mat-form-field appearance="fill" class="theme-dropdown-full">
            <mat-label>Select Theme</mat-label>
            <mat-select [(value)]="selectedTheme" (selectionChange)="setBaseTheme($event)">
                <mat-optgroup label="Default Themes">
                    <mat-option value="quartz">
                        <div class="theme-option">
                            <span class="theme-name">Quartz </span>
                            <span class="theme-badge default">Default</span>
                        </div>
                    </mat-option>
                    <mat-option value="balham">Balham</mat-option>
                    <mat-option value="material">Material</mat-option>
                    <mat-option value="alpine">Alpine</mat-option>
                </mat-optgroup>

                <mat-optgroup label="Color Schemes">
                    <mat-option value="quartzLightWarm">
                        <div class="theme-option">
                            <span class="theme-name">Light Warm</span>
                            <div class="color-swatch warm"></div>
                        </div>
                    </mat-option>
                    <mat-option value="quartzLightCold">
                        <div class="theme-option">
                            <span class="theme-name">Light Cold</span>
                            <div class="color-swatch cold"></div>
                        </div>
                    </mat-option>
                    <mat-option value="quartzDarkWarm">
                        <div class="theme-option">
                            <span class="theme-name">Dark Warm</span>
                            <div class="color-swatch dark-warm"></div>
                        </div>
                    </mat-option>
                    <mat-option value="quartzDarkBlue">
                        <div class="theme-option">
                            <span class="theme-name">Dark Blue</span>
                            <div class="color-swatch dark-blue"></div>
                        </div>
                    </mat-option>
                </mat-optgroup>

                <mat-optgroup label="Custom Themes">
                    <mat-option value="custom">
                        <div class="theme-option">
                            <span class="theme-name">Pink Theme</span>
                            <span class="theme-badge custom">Custom</span>
                        </div>
                    </mat-option>
                </mat-optgroup>
            </mat-select>
        </mat-form-field>
    </div>
</div>

